import type { UseQueryResult } from '@tanstack/react-query'
import { useQuery, useQueryClient } from '@tanstack/react-query'

import type { getAvailableActivationGroupParams } from '@/features/activationGroup/endpoints/activationGroups'
import {
  GET_AVAILABLE_ACTIVATION_GROUPS_API,
  getAvailableActivationGroups,
} from '@/features/activationGroup/endpoints/activationGroups'
import type { ActivationGroup } from '@/features/activationGroup/types'
import type { UseQueryOptions } from '@/types/queries'

export type UseActivationGroupsQueryResult = Omit<UseQueryResult, 'data'> & {
  activationGroups: ActivationGroup[] | null
}

export function useAvailableActivationGroupsQuery(
  params: getAvailableActivationGroupParams,
  options?: UseQueryOptions<ActivationGroup[]>,
): UseActivationGroupsQueryResult {
  const { data = null, ...queryResult } = useQuery<ActivationGroup[]>({
    ...options,
    queryFn: () => getAvailableActivationGroups(params),
    queryKey: [GET_AVAILABLE_ACTIVATION_GROUPS_API, params],
  })

  return {
    ...queryResult,
    activationGroups: data,
  }
}

export function useInvalidateAvailableActivationGroupsQuery() {
  const queryClient = useQueryClient()

  return () => queryClient.invalidateQueries({ queryKey: [GET_AVAILABLE_ACTIVATION_GROUPS_API] })
}
